import { isLEHotelAccommodationItemView } from 'lib/checkout/checkoutUtils'

function getItemViewAppliedLoyaltyUpgrade(itemView: App.Checkout.AnyItemView): App.Checkout.AccommodationItemViewLoyaltyAppliedUpgrade | undefined {
  if (isLEHotelAccommodationItemView(itemView) && itemView.loyaltyUpgradeAvailability && itemView.item.loyaltyAppliedUpgradeType) {
    const upgradeType = itemView.item.loyaltyAppliedUpgradeType
    const upgradeAvailability = itemView.loyaltyUpgradeAvailability

    if (upgradeType === 'room' &&
      (upgradeAvailability.upgradeAvailabilityType === 'room-only' || upgradeAvailability.upgradeAvailabilityType === 'room-and-package')) {
      return {
        upgradeType,
        originPackage: upgradeAvailability.originPackage,
        originTotals: upgradeAvailability.originTotals,
        originPrimaryTitle: upgradeAvailability.originPrimaryTitle,
        targetPackage: upgradeAvailability.roomUpgradePackage,
        targetTotals: upgradeAvailability.roomUpgradeTotals,
        targetPrimaryTitle: upgradeAvailability.roomUpgradePrimaryTitle,
      }
    }

    if (upgradeType === 'package' &&
      (upgradeAvailability.upgradeAvailabilityType === 'package-only' || upgradeAvailability.upgradeAvailabilityType === 'room-and-package')) {
      return {
        upgradeType,
        originPackage: upgradeAvailability.originPackage,
        originTotals: upgradeAvailability.originTotals,
        originPrimaryTitle: upgradeAvailability.originPrimaryTitle,
        targetPackage: upgradeAvailability.packageUpgradePackage,
        targetTotals: upgradeAvailability.packageUpgradeTotals,
        targetPrimaryTitle: upgradeAvailability.packageUpgradePrimaryTitle,
      }
    }
  }
}

export default getItemViewAppliedLoyaltyUpgrade
